module.exports = __webpack_public_path__ + "img/livemap_editbeacons_childbeaconsexample5.86348cd5.png";